import React, { useState, useEffect } from "react";
import { Row, Col, Descriptions, Divider } from 'antd';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CrDisplay = function CrDisplay(_ref) {
  var check = _ref.check;
  return /*#__PURE__*/_jsx("div", {
    style: {
      padding: '28px'
    },
    children: /*#__PURE__*/_jsx(Row, {
      gutter: 16,
      children: /*#__PURE__*/_jsx(Col, {
        span: 18,
        children: /*#__PURE__*/_jsxs("div", {
          className: "cr-wrapper",
          children: [/*#__PURE__*/_jsxs(Row, {
            gutter: 16,
            children: [/*#__PURE__*/_jsx(Col, {
              className: "gutter-row",
              span: 4,
              children: /*#__PURE__*/_jsx("img", {
                src: "/drawables/cap.png"
              })
            }), /*#__PURE__*/_jsx(Col, {
              className: "gutter-row",
              span: 10,
              children: /*#__PURE__*/_jsx("h4", {
                style: {
                  textAlign: "center",
                  marginTop: '40px'
                },
                children: /*#__PURE__*/_jsx("b", {
                  children: "COMPTE RENDU MEDICAL"
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Row, {
            gutter: 16,
            children: /*#__PURE__*/_jsxs(Col, {
              span: 18,
              children: [/*#__PURE__*/_jsx("div", {
                className: "cool-radius",
                style: {
                  background: '#FCD013'
                },
                children: check && /*#__PURE__*/_jsxs(Descriptions, {
                  column: 2,
                  children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                    labelStyle: {
                      fontWeight: 'Bold'
                    },
                    span: 2,
                    contentStyle: {
                      fontWeight: 'Bold'
                    },
                    label: "ID PATIENT",
                    children: check.customer.idnumber
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Pr\xE9nom"
                    }),
                    children: check.customer.firstname
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Nom"
                    }),
                    children: check.customer.lastname
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Tel."
                    }),
                    children: check.customer.mobile.slice(3)
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Genre"
                    }),
                    children: check.customer.gender == 'F' ? "Femme" : "Homme"
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Date de naissance"
                    }),
                    children: check.customer.birthdate
                  }), /*#__PURE__*/_jsx(Descriptions.Item, {
                    label: /*#__PURE__*/_jsx("b", {
                      children: "Profession"
                    }),
                    children: check.customer.job
                  })]
                })
              }), /*#__PURE__*/_jsx(Divider, {}), check && /*#__PURE__*/_jsxs(Descriptions, {
                column: 1,
                borderdred: true,
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Plaintes"
                  }),
                  children: check.plaintes
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Observation"
                  }),
                  children: check.resume
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Bilans"
                  })
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Traitement"
                  }),
                  children: check.traitement
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Conclusion"
                  }),
                  children: check.conclusion
                })]
              })]
            })
          })]
        })
      })
    })
  });
};
export default CrDisplay;